module.exports = __webpack_public_path__ + "img/sand-3.bdfc79e1.png";